import './style.css';
import NodeComponent from "../node";
import {SettingNodeIcon} from "./icons";

export function ImageMessageNode({ id, data }) {
    return (
        <NodeComponent title="Image" id={id} data={data} nodeTypeIcon={<SettingNodeIcon/>}>
            <div></div>
        </NodeComponent>
    );
}

